import { AlertMessage, Spinner } from "../../widgets";
import { useDeleteComponentMutation, useGetComponentsQuery } from "../../services/data/componentsApi";

import { IUserComponent } from "../../design/page/models";
import { Link } from "react-router-dom";

export const ComponentList = () => {
    const { data } = useGetComponentsQuery();
    const [deleteComponent, { isLoading: deleting, isError: isDeleteError, error: deleteError }] = useDeleteComponentMutation();

    const handleDeleteComponent = (component: IUserComponent) => {
        deleteComponent(component.id)
            .unwrap()
    }

    const customComponents = () => {
        return data
    }

    return (
        <div>
            <AlertMessage show={isDeleteError} type="Error" message={(deleteError as any)?.data?.error?.message || 'Failed to delete'} />
            {customComponents()?.map(component =>
                <div key={component.id} className="card bg-hover-light mb-2">
                    <div className="card-body py-2">
                        <div className="d-flex flex-row align-items-center">
                            <div className="flex-fill  me-2">
                                <h6 className="m-0">{component.name}</h6>
                                <div className="fs-7 mt-1">
                                    <label className="text-gray-700 m-0 me-2">Title: </label>
                                    <span className="fw-bold text-gray-700">{component.title}</span>
                                </div>
                            </div>
                            <div>
                                <Link
                                    to={`/design-component(${component.id})`}
                                    className="btn btn-sm py-2 lh-1 btn-primary me-2">
                                    <i className="las la-edit"></i>
                                    Design
                                </Link>
                                <button
                                    type="button"
                                    disabled={deleting}
                                    onClick={() => handleDeleteComponent(component)}
                                    className="btn btn-sm py-2 lh-1 btn-danger">
                                    {deleting ? <Spinner /> : <i className="las la-trash"></i>}
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>)
            }
        </div>)
}

